// src/api/index.js - API client for the frontend

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
});

export const getArticles = async (page = 1, limit = 10, category = '', search = '') => {
  try {
    const response = await api.get('/articles', {
      params: { page, limit, category, search },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching articles:', error);
    throw error;
  }
};

export const getArticle = async (id) => {
  try {
    const response = await api.get(`/articles/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching article:', error);
    throw error;
  }
};

export const downloadArticle = async (id) => {
  try {
    window.open(`${API_URL}/articles/${id}/download`, '_blank');
  } catch (error) {
    console.error('Error downloading article:', error);
    throw error;
  }
};

export const uploadArticle = async (articleData) => {
  try {
    const formData = new FormData();
    
    // Append text fields
    formData.append('title', articleData.title);
    formData.append('abstract', articleData.abstract);
    formData.append('category', articleData.category);
    
    if (articleData.content) {
      formData.append('content', articleData.content);
    }
    
    // Handle arrays
    formData.append('authors', JSON.stringify(articleData.authors));
    
    if (articleData.tags) {
      formData.append('tags', JSON.stringify(articleData.tags));
    }
    
    // Append PDF file
    formData.append('pdf', articleData.pdfFile);
    
    const response = await api.post('/articles', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  } catch (error) {
    console.error('Error uploading article:', error);
    throw error;
  }
};

export const getCategories = async () => {
  try {
    const response = await api.get('/categories');
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

export const submitContactForm = async (contactData) => {
  try {
    const response = await api.post('/contact', contactData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};
